interface FancyCheckboxProps {
  isChecked: boolean;
  onClick: any;
  title?: string;
}

export const FancyCheckbox = ({
  isChecked,
  onClick,
  title = 'Click to check',
}: FancyCheckboxProps) => {
  return (
    <button
      className={`fancy-checkbox${isChecked ? ' checked' : ''}`}
      onClick={onClick}
      title={title}
    >
      {isChecked && (
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px">
          <path d="M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z" />
        </svg>
      )}
    </button>
  );
};
